import { BaseModel } from "models/BaseModel";
import { ObjectWithAnyValues } from "utils/types";
import { Category } from "./Category";
import { Establishment } from "./Establishment";
import {
	CategoryProps,
	EstablishmentFields,
	EstablishmentProps,
	PartnerFields
} from "./types";

export class Partner extends BaseModel {
	[PartnerFields.ID]: string;
	[PartnerFields.TENANT_ID]: string;
	[PartnerFields.NAME]: string;
	[PartnerFields.LOGO_URL]: string;
	[PartnerFields.ESTABLISHMENT_IMAGE_URL]: string;
	[PartnerFields.DESCRIPTION]: string;
	[PartnerFields.STATUS]: number;
	[PartnerFields.CREATED_AT]: string;
	[PartnerFields.UPDATED_AT]: string;
	[PartnerFields.UPDATED_BY]: string;
	[PartnerFields.CATEGORIES]: CategoryProps[];
	[PartnerFields.CATEGORY_IDS]: number[];
	[PartnerFields.ESTABLISHMENTS]: EstablishmentProps[];

	constructor(data: any) {
		super(data);

		this[PartnerFields.ID] = data[PartnerFields.ID];
		this[PartnerFields.TENANT_ID] = data[PartnerFields.TENANT_ID];
		this[PartnerFields.NAME] = data[PartnerFields.NAME];
		this[PartnerFields.LOGO_URL] = data[PartnerFields.LOGO_URL];
		this[PartnerFields.ESTABLISHMENT_IMAGE_URL] =
			data[PartnerFields.ESTABLISHMENTS]?.[0]?.[EstablishmentFields.IMAGE];
		this[PartnerFields.DESCRIPTION] = data[PartnerFields.DESCRIPTION];
		this[PartnerFields.STATUS] = data[PartnerFields.STATUS];
		this[PartnerFields.CREATED_AT] = data[PartnerFields.CREATED_AT];
		this[PartnerFields.UPDATED_AT] = data[PartnerFields.UPDATED_AT];
		this[PartnerFields.UPDATED_BY] = data[PartnerFields.UPDATED_BY];
		this[PartnerFields.CATEGORY_IDS] = data[PartnerFields.CATEGORY_IDS] || [];

		this[PartnerFields.CATEGORIES] =
			data.categories && data.categories.map((item: any) => new Category(item));
		this[PartnerFields.ESTABLISHMENTS] = data.establishments
			? data.establishments.map((item: any) => new Establishment(item))
			: [Establishment.createEmpty()];
	}

	static override createFromResponse(response: ObjectWithAnyValues) {
		if (!response) {
			return response;
		}

		const categoryIds = response[PartnerFields.CATEGORIES]?.map(
			(category: any) => category.id
		);
		const tenant = new Partner({
			...response,
			[PartnerFields.CATEGORY_IDS]: categoryIds
		});
		return tenant;
	}
}
